import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTap = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 594.29 654.12",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M39.26,601.31C27,601.31,17,612.41,17,626V706.2c0,13.57,10,24.68,22.24,24.68s22.23-11.11,22.23-24.68V626C61.49,612.41,51.49,601.31,39.26,601.31Z",
			transform: "translate(0 -76.76)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.74,601.31c-12.23,0-22.23,11.1-22.23,24.68V706.2c0,13.57,10,24.68,22.23,24.68S126,719.77,126,706.2V626C126,612.41,116,601.31,103.74,601.31Z",
			transform: "translate(0 -76.76)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.23,601.31C156,601.31,146,612.41,146,626V706.2c0,13.57,10,24.68,22.23,24.68s22.24-11.11,22.24-24.68V626C190.47,612.41,180.46,601.31,168.23,601.31Z",
			transform: "translate(0 -76.76)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M569.61,217.15H431.55V134.63h34.81c14.19,0,25.79-13,25.79-28.93s-11.6-28.94-25.79-28.94H345.15c-14.18,0-25.79,13-25.79,28.94s11.61,28.93,25.79,28.93l46.43.45.08,85-287.07-1.45C42.69,218.61,0,267.2,0,335.2V553.8c0,15.91,3.44,27.88,17.62,27.88H190.41c14.18,0,17.48-18.4,17.48-34.31l2-97.5L571,446c14.14,0,22-5.94,22-21.86l1.29-179.25C594.3,228.92,583.8,217.15,569.61,217.15ZM191.7,399.39c-14.18,0-25.79,13-25.79,28.93l-.27,106.53H42.12v-202c0-36.17,28.37-66.56,61.9-66.56H548.89V399.39Z",
			transform: "translate(0 -76.76)"
		})
	]
});
export default SvgTap;
